import {AfterContentChecked, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Atividade} from 'src/app/core/atividade';
import {Acesso} from "../../../core/acesso";

@Component({
    selector: 'acoes-oficina',
    templateUrl: './acoes-oficina.component.html',
    styleUrls: ['./acoes-oficina.component.css']
})
export class AcoesOficinaComponent implements OnInit, AfterContentChecked {

    @Input() perfilAcesso: Acesso;

    @Input() oficina: Atividade;

    openFormCadastro = false;

    constructor(protected drc: ChangeDetectorRef) {
    }

    ngOnInit() {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }


    onGetAdicionar(evento) {
        this.openFormCadastro = evento;
    }

}
